import React, { useState, useRef } from 'react';
import { useLanguage } from '../LanguageContext';
import { useScrollReveal } from '../hooks/useScrollReveal';

const FloorPlan = () => {
  const { t } = useLanguage();
  const [selected, setSelected] = useState(0);
  const detailRef = useRef(null);
  const sectionRef = useScrollReveal(['.section-title', '.offers-intro p', '.offer-card'], { stagger: 0.06 });
  const cards = t.offers.cards;

  const colors = [
    'linear-gradient(135deg,#c6e9ff,#fef1d5)',
    'linear-gradient(135deg,#ffe5d9,#f9d7b6)',
    'linear-gradient(135deg,#d7f7ff,#ade1ff)',
    'linear-gradient(135deg,#e9f7de,#c0e4c9)',
    'linear-gradient(135deg,#f7f0ff,#d0c2ff)',
    'linear-gradient(135deg,#ffebf0,#ffd1d7)',
  ];

  return (
    <section className="offers-section" id="offers" ref={sectionRef}>
      <h2 className="section-title">{t.offers.title}</h2>
      <div className="offers-intro">
        {t.offers.paragraphs.map((p, i) => <p key={i}>{p}</p>)}
      </div>
      <div className="offers-grid">
        {cards.map((card, i) => (
          <button key={card.title} type="button"
            className={`offer-card ${selected === i ? 'active' : ''}`}
            onClick={() => { setSelected(i); detailRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' }); }}
          >
            <div className="offer-card-image" style={card.image
              ? { background: `url('/images/${card.image}') center/cover no-repeat` }
              : { background: colors[i % colors.length] }
            } />
            {card.badge && <span className="offer-card-badge">{card.badge}</span>}
            <div className="offer-card-body"><h3>{card.title}</h3></div>
          </button>
        ))}
      </div>
      <div className="offer-detail" ref={detailRef} id="offer-detail">
        <h3>{cards[selected].title}</h3>
        {(Array.isArray(cards[selected].description)
          ? cards[selected].description
          : [cards[selected].description]
        ).map((p, i) => <p key={i}>{p}</p>)}
        {cards[selected].images && (
          <div className="offer-detail-images">
            {cards[selected].images.map((src, i) => (
              <img key={i} src={`/${src}`} alt={`${cards[selected].title} ${i + 1}`} />
            ))}
          </div>
        )}
        <ul>{cards[selected].details.map((item, i) => <li key={i}>{item}</li>)}</ul>
      </div>
    </section>
  );
};

export default FloorPlan;
